import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { ProjectionVentilation } from 'routes/BudgetModule/components/BudgetProposal/Resource/Projection/helpers/types';

/**
 * Triggers a tracker event when user open the "New budget" modal.
 */
export const trackEventNewBudgetModaleOpened = () =>
    trackEventBudget(TRACKABLE_EVENTS.budget.settings.addBudget);

/**
 * Triggers a tracker event when user confirms the new budget creation.
 */
export const triggerTrackerConfirmNewBudgetCreation = () =>
    trackEventBudget(TRACKABLE_EVENTS.budget.settings.confirmAddBudget);

/**
 * Triggers a tracker event when user edit resources authorized to edit budget.
 */
export const trackEventResourcesAuthorizedChanged = (
    bpId: number | undefined,
    bpName: string | undefined,
    resourceSoftwaresId: (string | null)[],
) =>
    trackEventBudget(TRACKABLE_EVENTS.budget.settings.confirmResource, {
        budgetProposalId: bpId,
        budgetProposalName: bpName,
        resourceAuthorized: JSON.stringify(resourceSoftwaresId),
    });

/**
 * Triggers a tracker event when user edit atterrissage ventilation.
 */
export const trackEventAtterrissageVentilationUpdated = (
    bpId: number | undefined,
    bpName: string | undefined,
    ventilations: ProjectionVentilation.SoftwareIds[],
) =>
    trackEventBudget(
        TRACKABLE_EVENTS.budget.settings.confirmAtterrissageVentilation,
        {
            budgetProposalId: bpId,
            budgetProposalName: bpName,
            newAtterrissageVentilation: JSON.stringify(ventilations),
        },
    );

/**
 * Triggers a tracker event when user edit pluriannual projections ventilation.
 */
export const trackEventPluriannualVentilationUpdated = (
    bpId: number | undefined,
    bpName: string | undefined,
    ventilations: ProjectionVentilation.SoftwareIds[],
) => {
    trackEventBudget(
        TRACKABLE_EVENTS.budget.settings
            .confirmPluriannualProjectionVentilation,
        {
            budgetProposalId: bpId,
            budgetProposalName: bpName,
            newPluriannualProjectionsVentilation: JSON.stringify(ventilations),
        },
    );
};

/**
 * Triggers a tracker Event when user confirms Display settings duplication.
 */
export const trackEventDisplaySettingsDuplicationConfirm = (
    sourceBudgetProposalId?: number,
    sourceResourceSoftwareId?: string,
    budgetProposalIds?: number[],
    resourceSoftwareIds?: string[],
) => {
    trackEventBudget(
        TRACKABLE_EVENTS.budget.settings.confirmDuplicateSettings,
        {
            sourceBudgetProposalId,
            sourceResourceSoftwareId,
            budgetProposalIds,
            resourceSoftwareIds,
        },
    );
};

/**
 * Triggers a tracker Event when user confirms Argument duplication.
 */
export const trackEventArgumentDuplicationConfirmation = (
    sourceArgumentIds?: number[],
    budgetProposalIds?: number[],
    resource?: string[],
) =>
    trackEventBudget(
        TRACKABLE_EVENTS.budget.settings.duplicateArgumentaire
            .confirmDuplication,
        {
            sourceArgumentIds,
            budgetProposalIds,
            resource,
        },
    );

/**
 * Triggers a tracker Event when user click on initialize button.
 */
export const trackEventClickOnInitializeInscriptions = () =>
    trackEventBudget(TRACKABLE_EVENTS.budget.settings.initializeInscriptions);

/**
 * Triggers a tracker Event when user confirms inscriptions initialization.
 */
export const trackEventConfirmInitializeInscriptions = () =>
    trackEventBudget(
        TRACKABLE_EVENTS.budget.settings.confirmInitializeInscriptions,
    );
